import { sendSumoLog } from './sumoLogger';
import { updateCurNotifDetails, updateError } from '../../stores/notifications';

export const fetchTicketNotifDetails = async (
  token,
  notifId,
  dispatch,
  immediate = false
) => {
  const requestUrl = `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/notifications/${notifId}.json`;
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });

  try {
    const data = await fetch(requestUrl, {
      method: 'GET',
      headers,
    });

    if (!data.ok) {
      throw {
        message: `Ticket ${notifId} Notif Detail Fetch Data Not Okay: ${data.status}`,
        code: data.status,
      };
    }

    const jsonData = await data.json();
    if (immediate) {
      return jsonData;
    }

    updateCurNotifDetails(jsonData, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorMessage = isInternalError ? error.toString() : error.message;

    sendSumoLog(
      'fetchTicketNotifDetails',
      errorMessage,
      isInternalError ? 500 : error.code,
      dispatch,
      false
    );

    updateError(error, dispatch);
  }
};
